import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { LoadErrorBox } from "../../components/common/LoadErrorBox";
import { Card } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { RefreshCw, ChevronDown, ChevronUp } from "lucide-react";

const fmtTs = (iso) =>
  iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "";

export default function SuperAdminErrors() {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(null);
  const [loading, setLoading] = useState(false);

  const [failed, setFailed] = useState(false);
  const load = () => {
    setLoading(true);
    api.get("/admin/errori?full=true&limit=100")
      .then(({ data }) => { setRows(data); setFailed(false); })
      .catch(() => { setFailed(true); setRows((r) => r || []); })
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  return (
    <div data-testid="sa-errors-page">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h1 className="text-xl font-semibold text-text-primary">Registro errori</h1>
          <p className="text-sm text-text-muted">
            Ogni errore 500 del server, con traccia completa. Conservato 14 giorni su database:
            sopravvive alle pubblicazioni (i log del pod no).
          </p>
        </div>
        <Button variant="outline" size="sm" onClick={load} disabled={loading} data-testid="sa-errors-refresh">
          <RefreshCw size={14} className={loading ? "animate-spin" : ""} /> Aggiorna
        </Button>
      </div>

      {rows == null ? (
        <div className="text-sm text-text-muted py-8 text-center">Caricamento…</div>
      ) : failed ? (
        <Card><LoadErrorBox what="il registro errori" onRetry={load} testId="sa-errors-load-error" /></Card>
      ) : !rows.length ? (
        <Card className="p-8 text-center text-sm text-text-muted" data-testid="sa-errors-empty">
          Nessun errore registrato negli ultimi 14 giorni.
        </Card>
      ) : (
        <Card className="divide-y divide-border" data-testid="sa-errors-list">
          {rows.map((r, i) => (
            <div key={i} className="px-4 py-3">
              <button
                type="button"
                className="w-full flex items-start justify-between gap-3 text-left"
                onClick={() => setOpen(open === i ? null : i)}
                data-testid={`sa-error-row-${i}`}
              >
                <div className="min-w-0">
                  <div className="text-sm font-medium text-text-primary truncate">{r.error}</div>
                  <div className="text-xs text-text-muted mt-0.5">
                    {fmtTs(r.ts)} · {r.method} {r.path}
                    {r.org_id ? ` · org: ${r.org_id}` : ""}{r.user_id ? ` · utente: ${r.user_id}` : ""}
                  </div>
                </div>
                {open === i ? <ChevronUp size={16} className="shrink-0 text-text-muted" /> : <ChevronDown size={16} className="shrink-0 text-text-muted" />}
              </button>
              {open === i && r.stacktrace && (
                <pre className="mt-2 p-3 rounded-md bg-surface-2 border border-border text-[11px] leading-snug overflow-x-auto whitespace-pre-wrap" data-testid={`sa-error-trace-${i}`}>
                  {r.stacktrace}
                </pre>
              )}
            </div>
          ))}
        </Card>
      )}
    </div>
  );
}
